module.exports = __webpack_public_path__ + "static/media/improving.5e8b3fa9.svg";